import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { B2BCourseGrantPayload, BonificoOrderDTO } from "./BonificoOrderDTO.ts";

export function useGrantB2BCourses() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const grantCourses = async (
    orderId: string,
    grants: B2BCourseGrantPayload[],
  ): Promise<BonificoOrderDTO> => {
    setLoading(true);
    try {
      const { data } = await createAxiosInstance().post<BonificoOrderDTO>(
        `/bonifico-orders/${orderId}/b2b-course-grants`,
        { grants },
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { grantCourses, loading };
}
